/**
 * ============================================================
 * KML Parser v2
 * MiningSurveyWebGIS
 * ============================================================
 */

class KMLParser {
    /**
     * ============================================================
     * Parse XML
     * ============================================================
     */

    parse(xml) {
        const result = {
            name: "",

            folders: [],

            placemarks: [],
        };

        const documentNode = this.findFirst(xml, "Document");

        if (!documentNode) {
            throw new Error("Document node not found.");
        }

        result.name = this.getChildText(documentNode, "name");

        //--------------------------------------------------------
        // Parse child
        //--------------------------------------------------------

        for (const node of documentNode.children) {
            switch (node.localName) {
                case "Folder":
                    result.folders.push(this.parseFolder(node));

                    break;

                case "Placemark":
                    result.placemarks.push(this.parsePlacemark(node));

                    break;
            }
        }

        return result;
    }

    /**
     * ============================================================
     * Folder
     * ============================================================
     */

    parseFolder(folderNode) {
        const folder = {
            name: this.getChildText(folderNode, "name"),

            placemarks: [],
        };

        for (const node of folderNode.children) {
            if (node.localName === "Placemark") {
                folder.placemarks.push(this.parsePlacemark(node));
            }
        }

        return folder;
    }

    /**
     * ============================================================
     * Placemark
     * ============================================================
     */

    parsePlacemark(node) {
        return {
            name: this.getChildText(node, "name"),

            description: this.getChildText(node, "description"),

            styleUrl: this.getChildText(node, "styleUrl"),

            geometry: this.parseGeometry(node),

            properties: this.parseExtendedData(node),
        };
    }

    /**
     * ============================================================
     * Geometry
     * ============================================================
     */

    parseGeometry(node) {
        //--------------------------------------------------------
        // Point
        //--------------------------------------------------------

        let geom = this.findFirst(node, "Point");

        if (geom) {
            return {
                type: "Point",

                coordinates: this.parseCoordinateList(
                    this.getChildText(
                        geom,

                        "coordinates",
                    ),
                ),
            };
        }

        //--------------------------------------------------------
        // LineString
        //--------------------------------------------------------

        geom = this.findFirst(node, "LineString");

        if (geom) {
            return {
                type: "LineString",

                coordinates: this.parseCoordinateList(
                    this.getChildText(
                        geom,

                        "coordinates",
                    ),
                ),
            };
        }

        //--------------------------------------------------------
        // Polygon
        //--------------------------------------------------------

        geom = this.findFirst(node, "Polygon");

        if (geom) {
            const ring = this.findFirst(
                geom,

                "coordinates",
            );

            return {
                type: "Polygon",

                coordinates: this.parseCoordinateList(ring ? ring.textContent : ""),
            };
        }

        return null;
    }

    /**
     * ============================================================
     * ExtendedData
     * ============================================================
     */

    parseExtendedData(node) {
        const props = {};

        const ext = this.findFirst(
            node,

            "ExtendedData",
        );

        if (!ext) {
            return props;
        }

        const dataList = ext.getElementsByTagName("*");

        for (const item of dataList) {
            if (item.localName !== "Data") continue;

            const key = item.getAttribute("name");

            const valueNode = this.findFirst(
                item,

                "value",
            );

            props[key] = valueNode ? valueNode.textContent : "";
        }

        return props;
    }

    /**
     * ============================================================
     * Coordinate List
     * ============================================================
     */

    parseCoordinateList(text) {
        if (!text) {
            return [];
        }

        return text

            .trim()

            .split(/\s+/)

            .map((item) => {
                const p = item.split(",");

                return {
                    lng: Number(p[0]),

                    lat: Number(p[1]),

                    z: p.length > 2 ? Number(p[2]) : null,
                };
            });
    }

    /**
     * ============================================================
     * Helper
     * ============================================================
     */

    findFirst(node, name) {
        const list = node.getElementsByTagName("*");

        for (const item of list) {
            if (item.localName === name) {
                return item;
            }
        }

        return null;
    }

    getChildText(node, name) {
        for (const child of node.children) {
            if (child.localName === name) {
                return child.textContent.trim();
            }
        }

        return "";
    }
}

export default new KMLParser();
